export const driverInfoFieldConfiguration = [
  {
    name: "firstName",
    label: "First Name",
    type: "text",
    validation: {
      required: "First Name is required",
      minLength: { value: 2, message: "Minimum length is 2 characters" },
      maxLength: { value: 50, message: "Maximum length is 50 characters" },
    },
  },
  {
    name: "lastName",
    label: "Last Name",
    type: "text",
    validation: {
      required: "Last Name is required",
      minLength: { value: 2, message: "Minimum length is 2 characters" },
      maxLength: { value: 50, message: "Maximum length is 50 characters" },
    },
  },
  {
    name: "phoneNumber",
    label: "Phone Number",
    type: "text",
    validation: {
      required: "Phone number is required",
      pattern: {
        value: /^\d+$/,
        message: "Phone number must contain only digits",
      },
    },
  },
  {
    name: "birthDate",
    label: "Birth Date",
    type: "date",
  },
  {
    name: "workStartDate",
    label: "Work Start Date",
    type: "date",
  },
  {
    name: "terminationDate",
    label: "Termination Date",
    type: "datetime-local",
  },
  {
    name: "company",
    label: "Company",
    type: "select",
    options: [
      {
        value: "C1 Transportation",
        label: "C1 Transportation",
      },
      {
        value: "Fox C Group",
        label: "Fox C Group",
      },
    ],
  },
  {
    name: "driverCode",
    label: "Driver Code",
    type: "text",
  },
  {
    name: "driverType",
    label: "Driver Type",
    type: "select",
    options: [
      {
        value: "Company",
        label: "Company",
      },
      {
        value: "Owner",
        label: "Owner",
      },
    ],
  },
  {
    name: "payTo",
    label: "Company Settlement",
    type: "combo",
    dataKey: "settlementPayees",
  },
  {
    name: "payType",
    label: "Pay Type",
    type: "select",
    options: [
      {
        value: "Hourly",
        label: "Hourly",
      },
      {
        value: "Percentage",
        label: "Percentage",
      },
      { value: "Mileage", label: "Mileage" },
    ],
  },
  {
    name: "usedEld",
    label: "Used ELD",
    type: "select",
    options: [
      {
        value: "Samsara",
        label: "Samsara ELD",
      },
      {
        value: "Split",
        label: "Split ELD",
      },
      {
        value: "Other",
        label: "Other",
      },
      {
        value: "Outside",
        label: "Outside",
      },
      {
        value: "NotActive",
        label: "Not Active",
      },
    ],
  },
];
